import React from "react";
import "./Arrow.css";
const Arrow = ({ trend, size }) => {
  let arrowToPick = "arrow-up";
  if (trend === -1) arrowToPick = "arrow-down";
  if (trend === 0) arrowToPick = "equal";
  return (
    <span
      id="arrow"
      className={`icon-${arrowToPick}`}
      style={{ fontSize: size === "small" ? "2vh" : size === "xs" ? "1vh" : size === "large" ? "6vh" : "3vh" }}
    />
  );
};

export default Arrow;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/Arrow.js